import React, { createContext, useContext } from "react";
import ReactDOM from "react-dom/client";
import "./themes/default.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { syncHistoryWithStore } from "@ibm/mobx-react-router";
import { createBrowserHistory } from "history";
import { RootStore } from "./store/RootStore";
import "./translations/i18n";

const rootStore = new RootStore();

export const StoreContext = createContext<RootStore>(rootStore);
export const useStoreContext = () => useContext(StoreContext);

const browserHistory = createBrowserHistory();
const history = syncHistoryWithStore(browserHistory, rootStore.routerStore);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <StoreContext.Provider value={rootStore}>
    <App history={history} />
  </StoreContext.Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(null);
